import router from '../router'
import getInfo from "./getInfo"

function hasPermission(id, rid) {
  if (!rid) return true
  return id == rid
}
let sess = window.sessionStorage;
router.beforeEach(async function (to, from, next) {
  /* 路由发生变化修改页面meta */
  if (to.meta.content) {
    const head = document.getElementsByTagName('head')
    const meta = document.createElement('meta')
    meta.content = to.meta.content
    head[0].appendChild(meta)
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = await getInfo();
  }
  if (to.query.code) {
    next();
    return;
  };
  if (from.query.code) {
    let toQuery = JSON.parse(JSON.stringify(to.query));
    toQuery.code = from.query.code;
    next({
      path: to.path,
      query: toQuery
    })
  } else {
    next(
      // }
    )
  }
})



// WEBPACK FOOTER //
// ./src/router/permission.js